import * as Action from "../action/run_monitor_real_time.action";

const initState = {
    realTimeInfo: {
        isLoading: false, // 是否显示加载中
        leftList: [],
        rightList: [],
        dateTime: "",
        threePhase: "",
        devMeterInfo: {}
    },
    setting: {
        isLoading: false, // 设置列表加载中
        saveLoading: false,  // 保存按钮加载中
        settingList: [],
        visible: false,
    },
    searchParams: {
        superiorId: null,
        ceResSortNo: null,
        title: null,
        threePhase: false,
        ceResClass: "",
        measDataSideType: 1
    },
    historyCurve: {
        isLoading: false,
        labels: [],
        data: []
    },
    selectedData: {
        insAndCum: null,
        measCode: null,
        title: null,
    }
}

/**
 * 实时监控reducer
 */
const realTimeReducer = (state = initState, action) =>{
    switch (action.type) {
        case Action.RUN_MONITOR_REAL_TIME_DATA_TABLE_LOADING: // 实时信息表格是否加载中
            return {...state, realTimeInfo: {...state.realTimeInfo, isLoading: action.isLoading}}
        case Action.RUN_MONITOR_REAL_TIME_DATA_TABLE_INFO: // 实时信息表格数据
            return {...state, realTimeInfo: {...state.realTimeInfo, leftList: action.leftList, rightList: action.rightList, dateTime: action.dateTime,threePhase:action.threePhase,devMeterInfo:action.devMeterInfo}}
        case Action.RUN_MONITOR_REAL_TIME_SETTING_LIST_INFO_LOADING: // 设置列表加载中
            return {...state, setting: {...state.setting, isLoading: action.isLoading}}
        case Action.RUN_MONITOR_REAL_TIME_SETTING_LIST_INFO: // 设置列表数据初始化
            return {...state, setting: {...state.setting, settingList: action.settingList}}
        case Action.RUN_MONITOR_REAL_TIME_SETTING_MODAL_VISIBLE: // 模态框是否可见
            return {...state, setting: {...state.setting, visible: action.visible}}
        case Action.RUN_MONITOR_REAL_TIME_SETTING_MODAL_SAVING_LOADING: // 模态框提交按钮是否加载
            return {...state, setting: {...state.setting, saveLoading: action.isLoading}}
        case Action.RUN_MONITOR_REAL_TIME_SET_SEARCH_PARAMS: // 设置查询参数
            //return {...state, searchParams: {superiorId: action.superiorId, ceResSortNo: action.ceResSortNo, title: action.title != null ? action.title : state.searchParams.title, threePhase: action.threePhase}}
            return {...state, searchParams: action.params}
        case Action.RUN_MONITOR_REAL_TIME_SET_SELECTED_DATA: // 设置选中的数据
            return {...state, selectedData: {insAndCum: action.insAndCum,measCode: action.measCode, title: action.title, unit: action.unit}}
        case Action.RUN_MONITOR_REAL_TIME_HISTORY_CURVE_DATA: // 设置历史曲线数据
            // return {...state, historyCurve: {...state.historyCurve, labels: action.listTime, data: action.curve}}
            return {...state, historyCurve: {...state.historyCurve, data: action.data}}
        case Action.RUN_MONITOR_REAL_TIME_HISTORY_CURVE_LOADING: // 设置历史曲线图标加载中
            return {...state, historyCurve: {...state.historyCurve, isLoading: action.isLoading}}
        default: return state;
        case Action.RUN_MONITOR_REAL_TIME_RESET_DATA: // 重置曲线数据
            return initState;
    }
}

export default realTimeReducer;
